import { QuestionType } from '../../../../common';

// Map QuestionType to translation key suffix
export const getQuestionTypeLabelKey = (type: QuestionType): string => {
    const typeToKeyMap: Record<QuestionType, string> = {
        [QuestionType.SINGLE_SELECT]: 'singleSelection',
        [QuestionType.MULTIPLE_SELECT]: 'multipleSelection',
        [QuestionType.LONG_TEXT]: 'longText',
        [QuestionType.SHORT_TEXT]: 'shortText',
        [QuestionType.SELECT_DATE]: 'selectDate',
        [QuestionType.DATE_RANGE]: 'dateRange',
        [QuestionType.BOOLEAN]: 'trueFalse',
        [QuestionType.FILE_UPLOAD]: 'uploadFile',
        [QuestionType.NUMERIC]: 'numeric',
    };
    return typeToKeyMap[type] || 'shortText';
};

export const QUESTION_TYPE_OPTIONS = (t: (key: string) => string) => [
    {
        label: t('saveJob.singleSelection'),
        value: QuestionType.SINGLE_SELECT,
        key: QuestionType.SINGLE_SELECT,
    },
    {
        label: t('saveJob.multipleSelection'),
        value: QuestionType.MULTIPLE_SELECT,
        key: QuestionType.MULTIPLE_SELECT,
    },
    {
        label: t('saveJob.longText'),
        value: QuestionType.LONG_TEXT,
        key: QuestionType.LONG_TEXT,
    },
    {
        label: t('saveJob.shortText'),
        value: QuestionType.SHORT_TEXT,
        key: QuestionType.SHORT_TEXT,
    },
    {
        label: t('saveJob.selectDate'),
        value: QuestionType.SELECT_DATE,
        key: QuestionType.SELECT_DATE,
    },
    {
        label: t('saveJob.dateRange'),
        value: QuestionType.DATE_RANGE,
        key: QuestionType.DATE_RANGE,
    },
    {
        label: t('saveJob.trueFalse'),
        value: QuestionType.BOOLEAN,
        key: QuestionType.BOOLEAN,
    },
    {
        label: t('saveJob.uploadFile'),
        value: QuestionType.FILE_UPLOAD,
        key: QuestionType.FILE_UPLOAD,
    },
    {
        label: t('saveJob.numeric'),
        value: QuestionType.NUMERIC,
        key: QuestionType.NUMERIC,
    },
];

export const QUESTION_TYPES_WITH_DEALBREAKER = [
    QuestionType.SINGLE_SELECT,
    QuestionType.MULTIPLE_SELECT,
    QuestionType.BOOLEAN,
    QuestionType.NUMERIC,
    QuestionType.SELECT_DATE,
    QuestionType.DATE_RANGE,
];

export const QUESTION_TYPES_WITH_OPTIONS = [
    QuestionType.SINGLE_SELECT,
    QuestionType.MULTIPLE_SELECT,
];

export const QUESTION_TYPES_WITH_BOOLEAN_OPTIONS = [QuestionType.BOOLEAN];

export const QUESTION_TYPES_WITH_TEXT_EDITOR = [QuestionType.LONG_TEXT];

export const QUESTION_TYPES_WITH_SHORT_TEXT = [QuestionType.SHORT_TEXT];

export const QUESTION_TYPES_WITH_FILE_UPLOAD = [QuestionType.FILE_UPLOAD];

export const QUESTION_TYPES_WITH_DATE_PICKER = [QuestionType.SELECT_DATE];

export const QUESTION_TYPES_WITH_DATE_RANGE = [QuestionType.DATE_RANGE];

export const QUESTION_TYPES_WITH_NUMERIC = [QuestionType.NUMERIC];
